import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import { useSite } from "../context/SiteContext";

export function Footer() {
  const { settings, categories, pages } = useSite();
  return (
    <footer id="contatti" className="border-t border-line bg-surface">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-2">
          <img src="/logo-enertel.png" alt={settings.company_name || "Enertel Solutions"} className="h-20 w-auto" />
          <p className="mt-4 text-ink-muted text-sm max-w-sm leading-relaxed">
            {settings.footer_description || settings.tagline || "Fibra, Luce, Gas e Fotovoltaico in un'unica soluzione affidabile."}
          </p>
          <ul className="mt-5 space-y-2 text-sm text-ink-muted">
            {settings.footer_address && (
              <li className="flex items-center gap-2"><MapPin className="w-4 h-4 text-brand" /> {settings.footer_address}</li>
            )}
            {settings.footer_email && (
              <li><a href={`mailto:${settings.footer_email}`} className="flex items-center gap-2 hover:text-brand transition-colors"><Mail className="w-4 h-4 text-brand" /> {settings.footer_email}</a></li>
            )}
            {settings.footer_phone && (
              <li><a href={`tel:${settings.footer_phone.replace(/[^0-9+]/g, "")}`} className="flex items-center gap-2 hover:text-brand transition-colors"><Phone className="w-4 h-4 text-brand" /> {settings.footer_phone}</a></li>
            )}
          </ul>
        </div>
        <div>
          <div className="label-eyebrow text-ink-muted mb-4">Servizi</div>
          <ul className="space-y-2 text-sm text-ink-muted">
            {categories.map((c) => (
              <li key={c.slug}>
                <Link to={`/servizi/${c.slug}`} className="hover:text-brand transition-colors">
                  {c.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <div className="label-eyebrow text-ink-muted mb-4">Informazioni</div>
          <ul className="space-y-2 text-sm text-ink-muted">
            <li><Link to="/carta-fedelta" className="hover:text-brand transition-colors">Carta Fedeltà</Link></li>
            {(pages || []).map((p) => (
              <li key={p.slug}>
                <Link to={`/p/${p.slug}`} className="hover:text-brand transition-colors">{p.title}</Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <div className="border-t border-line py-5 text-center text-xs text-ink-muted">
        {settings.footer_copyright || `© ${new Date().getFullYear()} ${settings.company_name || "Enertel Solutions"}. Tutti i diritti riservati.`}
        {settings.footer_vat && <span> · P.IVA {settings.footer_vat}</span>}
      </div>
    </footer>
  );
}
